import React, {useState} from 'react';
import {doc} from '@sail/icons/react/Icon';
import {css, Icon, view} from '@sail/ui/deprecated';
import {Attachment} from './Attachment';

const isImage = (attachment: Attachment): boolean =>
  ['image/png', 'image/jpeg'].includes(attachment.mimeType);

type PreviewImageProps = {
  attachment: Attachment;
};

export const PreviewImage = ({attachment}: PreviewImageProps): JSX.Element => {
  const [dataUrl, setDataUrl] = useState<string | undefined>(undefined);

  React.useEffect(() => {
    if (!isImage(attachment)) {
      return;
    }

    const fileReader = new FileReader();
    fileReader.onload = () => {
      if (typeof fileReader.result === 'string') {
        setDataUrl(fileReader.result);
      }
    };
    fileReader.readAsDataURL(attachment.file);
    return () => {
      if (fileReader.readyState === fileReader.LOADING) {
        fileReader.abort();
      }
    };
  }, [attachment]);

  return (
    <view.span
      css={{
        width: css.value('$space.xlarge'),
        minWidth: css.value('$space.xlarge'),
        height: css.value('$space.xlarge'),
        borderStyle: css.value('solid'),
        borderColor: css.value('$borderColor.neutral'),
        borderWidth: css.value('$space.1'),
        borderRadius: 'xsmall',
        display: css.value('flex'),
        alignItems: css.value('center'),
        justifyContent: css.value('center'),
      }}
    >
      {isImage(attachment) && dataUrl ? (
        <view.img
          src={dataUrl}
          alt={attachment.fileName}
          data-testid="image-preview"
          css={{
            width: 'fill',
            height: 'fill',
            objectFit: css.value('fill'),
          }}
        />
      ) : (
        <Icon
          icon={doc}
          size="small"
          data-testid="document-preview-icon"
          css={{}}
        />
      )}
    </view.span>
  );
};
